import { AREA_INDUSTRY_USER_MNG } from '@/api/apiModules'
export default {
  refreshInterval: false,
  viewType: 'table',
  module: AREA_INDUSTRY_USER_MNG,
  relationSearch: true,
  sortArr: [
    {
      fieldName: 'area',
      direction: 'ASC'
    }
  ],
  allowStatus: {},
  toolbar: {
    searchPlaceholder: '请输入区域&部门',
    moreBtnWidth: 160,
    searchFieldNameArr: ['area'],
    hasColAdjustment: true,
    items: [
      {
        slot: 'refresh-rigtht',
        label: 'create',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'areaIndustryUserCreate'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          label: '区域&部门',
          prop: 'area',
          width: '160px',
          sortField: 'area'
        },
        dataType: 'custom',
        custom(row, _h, value, e) {
          return row.area
        },
        filter: true,
        url: `global/enum/area`
      },
      {
        props: {
          label: '行业',
          prop: 'industryNames'
        }
      },
      {
        props: {
          label: '售后主管',
          width: '320px',
          prop: 'postsalesLeaderIds'
        }
      },
      {
        props: {
          label: '售后',
          width: '320px',
          prop: 'postsalesIds'
        }
      },
      {
        props: {
          label: '拓展',
          width: '220px',
          prop: 'extensionIds'
        }
      },
      {
        props: {
          label: '创建时间',
          prop: 'createTime',
          width: '160px',
          sortField: 'createTime'
        },
        dataType: 'date'
      },
      {
        props: {
          showBtnNum: '1',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'areaIndustryUserEdit',
        name: 'AreaIndustryUserEdit'
      }
    ]
  }
}
